import React, { FC } from 'react'
import { StyledMusicPlayerArtistName } from './MusicPlayerArtistName.styles'

export const MusicPlayerArtistName: FC<{ artistName: string }> = ({ artistName }) => {
  return <StyledMusicPlayerArtistName>{artistName}</StyledMusicPlayerArtistName>
}
